import { Model } from 'modules/core/lib/mobx-rest'

interface IExpensesCategoryContractsTaxonomy {
  [key: string]: any
}

class ExpensesCategoryContractsTaxonomy extends Model<IExpensesCategoryContractsTaxonomy> {
  static urlRoot() {
    return '/payroll/expenses_categories_contracts_taxonomies'
  }
}

export default ExpensesCategoryContractsTaxonomy
